// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-tab-buttons {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 1rem;
  margin: 0rem 1rem;
}
.header-tab-buttons .header-tab-buttons-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2rem;
  min-width: 6rem;
  border-radius: 1rem;
  padding: 0.5rem;
}
.header-tab-buttons .header-tab-buttons-tab .cdn-icon-header-tabs {
  --icon-height: 1rem;
  --icon-width: 1rem;
  padding-right: 0.5rem;
  filter: brightness(100);
}
.header-tab-buttons .header-tab-buttons-tab p {
  font-size: 0.94rem;
  margin: none;
  color: var(--ion-color-light);
  text-transform: uppercase;
  font-family: var(--font-med);
  white-space: nowrap;
}
.header-tab-buttons .header-tab-active {
  background-color: var(--ion-color-light);
}
.header-tab-buttons .header-tab-active .cdn-icon-header-tabs {
  filter: brightness(0);
}
.header-tab-buttons .header-tab-active p {
  color: var(--ion-color-primary);
}

@media screen and (max-width: 768px) {
  .header-tab-buttons {
    justify-content: space-evenly;
    gap: 0.5rem;
    margin: 0rem 0.5rem;
  }
  .header-tab-buttons .header-tab-buttons-tab {
    flex-direction: column;
    min-width: 2rem;
    border-radius: 0.5rem;
    padding: 0.15rem;
  }
  .header-tab-buttons .header-tab-buttons-tab .cdn-icon-header-tabs {
    padding-right: 0;
  }
  .header-tab-buttons .header-tab-buttons-tab p {
    text-align: center;
    font-size: 0.5rem;
    margin: 0;
    margin-top: 0.2rem;
  }
}
@media screen and (max-width: 450px) {
  .header-tab-buttons {
    margin: 0rem 0.25rem;
  }
  .header-tab-buttons .header-tab-buttons-tab {
    padding: 0.05rem;
  }
  .header-tab-buttons .header-tab-buttons-tab p {
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/lobby/header-tabs/header-tabs.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,iBAAA;AACJ;AACI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AACR;AACQ;EACI,mBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,uBAAA;AACZ;AAEQ;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;AAAZ;AAII;EACI,wCAAA;AAFR;AAIQ;EAEI,qBAAA;AAFZ;AAMQ;EACI,+BAAA;AAJZ;;AAUA;EAEI;IACI,6BAAA;IACA,WAAA;IACA,mBAAA;EARN;EAUM;IACI,sBAAA;IACA,eAAA;IACA,qBAAA;IACA,gBAAA;EARV;EAUU;IACI,gBAAA;EARd;EAWU;IACI,kBAAA;IACA,iBAAA;IACA,SAAA;IACA,kBAAA;EATd;AACF;AAeA;EACI;IACI,oBAAA;EAbN;EAeM;IACI,gBAAA;EAbV;EAeU;IACI,mBAAA;EAbd;AACF","sourcesContent":[".header-tab-buttons {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 1rem;\n    margin: 0rem 1rem;\n\n    .header-tab-buttons-tab {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 2rem;\n        min-width: 6rem;\n        border-radius: 1rem;\n        padding: .5rem;\n\n        .cdn-icon-header-tabs {\n            --icon-height: 1rem;\n            --icon-width: 1rem;\n            padding-right: 0.5rem;\n            -webkit-filter: brightness(10);\n            filter: brightness(100);\n        }\n\n        p {\n            font-size: 0.94rem;\n            margin: none;\n            color: var(--ion-color-light);\n            text-transform: uppercase;\n            font-family: var(--font-med);\n            white-space: nowrap;\n        }\n    }\n\n    .header-tab-active {\n        background-color: var(--ion-color-light);\n\n        .cdn-icon-header-tabs {\n            -webkit-filter: brightness(0);\n            filter: brightness(0);\n\n        }\n\n        p {\n            color: var(--ion-color-primary);\n        }\n    }\n}\n\n\n@media screen and (max-width: 768px) {\n\n    .header-tab-buttons {\n        justify-content: space-evenly;\n        gap: .5rem;\n        margin: 0rem .5rem;\n\n        .header-tab-buttons-tab {\n            flex-direction: column;\n            min-width: 2rem;\n            border-radius: 0.5rem;\n            padding: 0.15rem;\n\n            .cdn-icon-header-tabs {\n                padding-right: 0;\n            }\n\n            p {\n                text-align: center;\n                font-size: 0.5rem;\n                margin: 0;\n                margin-top: 0.2rem;\n            }\n        }\n    }\n\n}\n\n@media screen and (max-width: 450px) {\n    .header-tab-buttons {\n        margin: 0rem .25rem;\n\n        .header-tab-buttons-tab {\n            padding: .05rem;\n\n            p {\n                white-space: nowrap;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
